"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colors = void 0;
var colors = {
  highlight: '#EFEFF0',
  muted: '#B4ADAA',
  primary: '#ff671b',
  text: '#000000',
  background: '#FFFFFF',
  secondary: '#FFFFFF',
  accent: '#4E4F51',
  green: '#13CE66',
  red: '#d0021b'
};
exports.colors = colors;